import {
  axiosConfig,
  del,
  get,
  patch,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  FeedbackAdminPayload,
  FeedbackRecord,
} from "@project/types/feedback";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/feedbacks`;
const SILENT: RequestConfig = { showNotification: false };

class FeedbackService {
  listFeedbacksPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<FeedbackRecord>> => {
    return fetchListPage<FeedbackRecord>(`${BASE}/`, query);
  };

  getFeedback = async (id: number): Promise<FeedbackRecord | undefined> => {
    const data = await get<ApiItemResponse<FeedbackRecord> | FeedbackRecord>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (payload: FeedbackAdminPayload): Promise<FeedbackRecord> => {
    const response = await axiosConfig.post<
      ApiItemResponse<FeedbackRecord> | FeedbackRecord
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(response.data);
    if (!item) {
      throw new Error("Failed to submit feedback.");
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<FeedbackAdminPayload>
  ): Promise<FeedbackRecord | undefined> => {
    const data = await patch<
      ApiItemResponse<FeedbackRecord> | FeedbackRecord,
      Partial<FeedbackAdminPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const feedbackService = new FeedbackService();
